import React from 'react'
import { Redirect } from 'react-router'
import { withAsync } from '@/components/Async'
import UserLayout from '@/layouts/Blank'
import type { RouteConfig } from 'react-router-config'

const routes: RouteConfig[] = [
  {
    path: '/user',
    component: UserLayout,
    routes: [
      {
        name: 'bind',
        path: '/bind/:source',
        component: withAsync(() => import(/* webpackChunkName: "Bind" */ '@/containers/StoreAuth/Bind')),
        exact: true,
      },
      {
        name: 'bindEC2',
        path: '/bindEC2',
        component: withAsync(() => import(/* webpackChunkName: "BindEC2" */ '@/containers/StoreAuth/BindEC2')),
        exact: true,
      },
      /**
       * TODO: 可以去掉，已经在oneclub承载了
       */
      {
        name: 'appeal',
        path: '/appeal',
        component: withAsync(() => import(/* webpackChunkName: "appeal" */ '@/containers/User/Appeal')),
        exact: true,
      },
      {
        path: '/*',
        component() {
          return <Redirect to="/" />
        },
        exact: true,
      },
    ],
  },
]

export default routes
